<template>
  <v-data-table
    ref="wDataTable"
    :headers="headers"
    :items="items"
    :search="get_global.search[name]"
    :item-key="itemkey"
    :sort-by="sortby"
    :sort-desc="sortdesc"
    :group-by="groupby"
    :group-desc="sortdesc"
    :no-data-text="pageLang.datatable.no_data"
    :no-results-text="pageLang.datatable.no_results"
    :footer-props="{
      'items-per-page-options': paginationOptions,
      'items-per-page-text': pageLang.datatable.items_per_page
    }"
    :items-per-page="itemsperpage"
    :hide-default-header="is_mobile || hideheader || (!socketInfo.firstLoad || (!socketInfo.customDataFirstLoad && customdata === true))"
    :hide-default-footer="hidefooter"
    :show-expand="showExpand"
    :single-expand="showExpand"
    expand-icon="mdi-chevron-down"
    :expanded.sync="expanded"
    calculate-widths
    :custom-filter="customFilter"
    :class="{ mobile: is_mobile }"
  >
    <template v-if="search" v-slot:top>
      <Search
       :name="name"
      >
        <slot name="toolbar"/>
      </Search>
    </template>
    <template v-if="groupby" v-slot:[`group.header`]="{ group, headers, toggle, isOpen }">
      <td :colspan="headers.length" @click="toggle" :class="{ 'group-items': true, isOpen }">
        <v-btn small :color="(isOpen ? 'blue' : 'grey')" icon :ref="group" :data-open="isOpen">
          <v-icon>{{ (isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down') }}</v-icon>
        </v-btn>
        <template v-if="groupSlot">
          <slot
            name="groupName"
            :group="group"
          ></slot>
        </template>
        <template v-else>
          {{ (group ? group : lang.categories.new.no_cat) }}
        </template>
      </td>
    </template>
    <template v-slot:expanded-item="{ item, expand, isExpanded }" v-if="showExpand">
      <v-expand-transition>
        <tr
          v-show="transitioned[item.id]"
          :key="item.id"
          class="ma-0 pa-0 expansion-row"
          style="height: auto;"
        >
          <slot
            name="expansion"
            :item="item"
            :isExpanded="isExpanded"
            :expand="expand"
          ></slot>
        </tr>
      </v-expand-transition>
    </template>
    <template v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }" v-if="showExpand">
      <v-btn
        @click.stop="toggleExpand({ item, isExpanded, expand })"
        icon
        dark
        small
        class="expand-btn mx-2"
        :class="{ active: isExpanded }"
      >
        <v-icon light color="grey darken-4">
          mdi-chevron-down
        </v-icon>
      </v-btn>
    </template>
    <template v-if="(!socketInfo.firstLoad || (!socketInfo.customDataFirstLoad && customdata === true))" v-slot:body>
      <tr>
        <td :colspan="tablehdrs.length" class="px-0">
          <v-sheet
            v-if="!is_mobile"
            :color="`grey ${login_data.theme.dark ? 'darken-2' : 'lighten-4'}`"
            class="pa-0 ma-0"
          >
            <v-skeleton-loader
              class="pa-0 ma-0"
              :type="`table-tbody@${(itemsperpage / 5)}`"
              loading
            ></v-skeleton-loader>
          </v-sheet>
          <v-sheet
            v-else
            :color="`grey ${login_data.theme.dark ? 'darken-2' : 'lighten-4'}`"
            class="pa-0 ma-0"
          >
            <v-skeleton-loader
              class="pa-0 ma-0"
              :type="`list-item-three-line@${(itemsperpage / 5) * 2}`"
              loading
            ></v-skeleton-loader>
          </v-sheet>
        </td>
      </tr>
    </template>
    <template v-else v-slot:item="{ item, isExpanded, expand }" >
      <slot
        v-if="!is_mobile || !$scopedSlots.mobile"
        name="default"
        :item="item"
        :isExpanded="isExpanded"
        :expand="expand"
        :toggleExpand="toggleExpand"
      ></slot>
      <slot
        v-else
        name="mobile"
        :item="item"
        :isExpanded="isExpanded"
        :expand="expand"
        :toggleExpand="toggleExpand"
      ></slot>
    </template>
  </v-data-table>
</template>

<script>
import Search from '@/templates/global/Search'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { Search },
  mixins: [ appdata, utils ],
  props: {
    name: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    tablehdrs: {
      type: Array,
      required: true
    },
    search: {
      type: Boolean,
      default: false
    },
    itemkey: {
      type: String,
      default: 'id'
    },
    sortby: {
      type: String,
      default: 'id'
    },
    groupby: {
      type: String,
      default: null
    },
    itemsperpage: {
      type: Number,
      default: 15
    },
    sortdesc: {
      type: Boolean,
      default: true
    },
    customdata: {
      type: Boolean,
      default: false
    },
    paginationOptions: {
      type: Array,
      default: function () {
        return [10, 15, 20, 30, 50]
      }
    },
    showExpand: {
      type: Boolean,
      default: false
    },
    hideheader: {
      type: Boolean,
      default: false
    },
    hidefooter: {
      type: Boolean,
      default: false
    },
    customFilter: {
      type: Function,
      default: (value, search, item) => Object.keys(item).some(i => (JSON.stringify(item[i]).toLowerCase().indexOf(search.toString().toLowerCase()) > -1))
    }
  },
  data () {
    return {
      expanded: [],
      transitioned: [],
      closeTimeouts: {},
      options: {
        page: 1,
        itemsPerPage: this.itemsperpage,
        sortBy: this.sortby,
        sortDesc: this.sortdesc,
        groupBy: this.groupby,
        groupDesc: this.sortdesc
      }
    }
  },
  computed: {
    headers () {
      const expandHeader = [{
        text: '',
        value: 'data-table-expand',
        width: '50px'
      }]
      return (this.showExpand ? expandHeader.concat(this.tablehdrs) : this.tablehdrs)
    },
    pageLang () {
      let path = this.name.split('.') || []
      switch (path.length) {
        case 1: 
          return this.lang[path[0]]
        case 2: 
          return this.lang[path[0]][path[1]]
        case 3: 
          return this.lang[path[0]][path[1]][path[2]]
        default:
          return {}
      }
    }
  },
  methods: {
    groupSlot () {
      return this.$slots.groupName
    },
    toggleExpand (props) {
      if (this.showExpand) {
        const item = props.item
        if (props.isExpanded && this.transitioned[item.id]) {
          this.closeExpand(item)
        } else {
          clearTimeout(this.closeTimeouts[item.id])
          props.expand(true)
          this.$nextTick(() => this.$set(this.transitioned, item.id, true))
          this.$nextTick(() => this.expanded.forEach(i => i !== item && this.closeExpand(i)))
        }
      }
    },
    closeExpand (item) {
      this.$set(this.transitioned, item.id, false)
      this.closeTimeouts[item.id] = setTimeout(() => this.$refs.wDataTable.expand(item, false), 555)
    }
  }
}
</script>

<style src="@/styles/components/datatable.scss" lang="scss"></style>
